/**
 * @module  Experience
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

export const OTP_CONSTANTS = {
  PERMISSION_PATH: '/RepdashU1/Verification-care.elements.BYPASS_VERIFICATION',
  ENABLE: 'Enable',
  DISABLE: 'Disable',
  TEMPORARY_PIN_VALIDATION: 'temp-pin',
  BYPASS: 'bypass',
  UNAUTHORIZED: 'unauthorized',
  PHOTO_ID: 'photo-id',
  TEMP_PIN: 'temp-pin',
  PIN: 'pin',
  SMS: 'sms',
  EMAIL: 'email',
  UNABLE_TO_SEND_OTP: 'unable to send otp',
  WARNING: 'Warning',
  TRANSACTION_NOT_ALLOWED: 'This transaction is not allowed.',
};

export const OTP_FORM_CONSTANTS = {
  ZIPCODE: 'zipCode',
  ONE_TIME_PIN: 'oneTimePin',
  MANAGER_USERNAME: 'managerUsername',
  MANAGER_PASSWORD: 'managerPassword',
};
